import { compose } from 'redux';
import type { AppState } from '../AppState';
import type { UsersState } from './reducer';

const selectUsersDomain = (state: AppState): UsersState => state.users;

export const selectLoadUsersWebData = compose((domainState: UsersState) => domainState.loadUsersWebData, selectUsersDomain);

export const selectDeleteUserWebData = compose((domainState: UsersState) => domainState.deleteUserWebData, selectUsersDomain);

export const selectAccessibleFleetsWebData = compose((domainState: UsersState) => domainState.accessibleFleetsWebData, selectUsersDomain);
